import styled from "styled-components";

export const OrderHistoryWrapper = styled.div`
  grid-area: OrderHistory;
  /* border: 1px solid black; */
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: 0 0 0 20px; */
  /* padding-left: 22px; */
  align-items : center;

  width : 100%;
  /* border: 1px solid black; */
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 420px;
  width :100%;
  /* border: 1px solid black; */
`;

export const PaginationContainer = styled.div`
  padding: 20px;
  margin-top: 44px;
  margin-bottom : 10px;
  border-top: 2px solid #eee;
  border-bottom: 2px solid #eee;
  width: 100%;
  box-sizing : border-box;
`;

